import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadStepCompoundBoughtOrOrderedCar,
  createBoughtOrOrderedCarChatFlow,
  MatomoHelmet,
} from '@wkda/marketing-components';
import { defaultFlowWithoutConsent } from '@wkda/conversational-carlead';

function CarleadCreation() {
  return (
    <>
      <MatomoHelmet />
      <BaseConversationalLeadPage
        form={defaultFlowWithoutConsent}
        customFlow={createBoughtOrOrderedCarChatFlow}
        manualForm={<CarleadStepCompoundBoughtOrOrderedCar />}
        content={CarleadHIWWhyChooseWkdaFaq}
        showTrustPilot={true}
      />
    </>
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
